export const MESSAGE_MAX_LENGTH = 256
